import React from 'react';
import { connect } from 'react-redux';
import { startSetPopulation } from '../actions/globalState';
import {Select} from 'antd';
const Option = Select.Option;

export class PopulationType extends React.Component {

  onPopulationChange = (value) => {
    this.props.startSetPopulation(value);
  };
  render() {
    //console.log('geo type component', this.props)
    return (
      <Select  size="large"
        className="population"
        value={this.props.population}
        onChange={value => this.onPopulationChange(value)}
        >
        {
          this.props.populations.length === 0 ? 
          (<Option value="persons">Persons</Option>) : 
          ( this.props.populations.map((item, index) => {
            return <Option key={index} value={item.population}>{item.population}</Option>
          }))
        }
      </Select>
    )
  }
}

const mapStateToProps = (state) => ({
  population: state.globalState.population,
  populations: state.globalState.populations
});

const mapDispatchToProps = (dispatch) => ({
  startSetPopulation: (text) => dispatch(startSetPopulation(text))
});

export default connect(mapStateToProps, mapDispatchToProps)(PopulationType);



// WEBPACK FOOTER //
// ./src/components/PopulationType.js